import clsx from 'clsx';
import { ComponentProps, FC } from 'react';
import styles from './Radio.module.css';

export interface RadioProps
  extends Omit<ComponentProps<'input'>, 'ref' | 'type'> {}

export const Radio: FC<RadioProps> = ({
  children,
  className,
  checked,
  ...rest
}) => (
  <label className={clsx(styles.container, className)}>
    <input className={styles.radio} type="radio" checked={checked} {...rest} />
    <svg
      className={styles.icn}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={clsx(styles.outerCircle, checked && styles.checked)}
        cx="11"
        cy="11"
        r="9"
      />
      <circle
        className={clsx(styles.innerCircle, checked && styles.checked)}
        cx="11"
        cy="11"
        r="4.8"
      />
    </svg>
    <div className={styles.label}>{children}</div>
  </label>
);
